import React from 'react';
import { Image, View } from 'react-native';
import NativeVideo from 'react-native-video';
import styled from 'styled-components';

type Props = React.ComponentProps<typeof NativeVideo>;

const Player = styled.video`
  max-width: 100%;
  max-height: 100%;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const Video: React.FC<Props> = ({
  source,
  style,
  paused,
  repeat,
  muted,
  onLoad,
}) => {
  const ref = React.useRef<HTMLVideoElement>(null);
  const [loaded, setLoaded] = React.useState(false);

  React.useEffect(() => {
    if (loaded) {
      if (paused) {
        ref.current?.pause();
      } else {
        ref.current?.play();
      }
    }
  }, [loaded, paused]);

  const handleCanPlay = React.useCallback(() => {
    setLoaded(true);
    // @ts-ignore
    onLoad?.({ duration: ref.current?.duration ?? 0 });
  }, [onLoad]);

  return (
    <View
      // @ts-ignore
      style={style}
    >
      <Player
        onCanPlay={handleCanPlay}
        autoPlay
        muted={muted}
        playsInline
        loop={repeat}
        ref={ref}
        src={
          typeof source === 'object'
            ? source.uri
            : Image.resolveAssetSource(source).uri
        }
      />
    </View>
  );
};

export default Video;
